import React from 'react';
import {
  toast,
} from 'react-toastify';

import {
  Button,
  Dropdown,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

import * as S from './styled';

type Action = {
  name: string,
};

type Props = {
  id: number,
  name: string,
  readOnly: boolean,
  isClient: boolean,
  actions: Array<Action>,
  visibleBookmark?: boolean,
  onSaveName: { (): void },
  onEnter: {(): void},
  handleAssignBookmark: {(): void},
  bookmarks: Object,
};

const WorkoutExercisesHeader = ({
  id,
  name,
  actions,
  readOnly,
  isClient,
  visibleBookmark,
  onSaveName,
  onEnter,
  handleAssignBookmark,
  bookmarks,
}: Props) => (
  <S.Header>
    <Flex fillSpace spacing={10}>
      {visibleBookmark && (
        <S.BookmarkIcon
          bookmarks={bookmarks}
          id={id}
          onClick={handleAssignBookmark}
        >
          {bookmarks[id] ? (
            <S.BookmarkActive />
          ) : (
            <S.Bookmark />
          )}
        </S.BookmarkIcon>
      )}
      {readOnly ? (
        <S.Title visibleBookmark={visibleBookmark}>
          {name}
        </S.Title>
      ) : (
        <S.TitleInput
          visibleBookmark={visibleBookmark}
          defaultValue={name}
          onSave={onSaveName}
          onSaveEnter={onSaveName}
        />
      )}
    </Flex>
    {!readOnly && (
      <Flex>
        <Dropdown
          trigger={(
            <S.Actions />
          )}
          items={actions}
        />
      </Flex>
    )}

    {isClient && (
      <Flex align="center" spacing={10}>
        <Button
          ghost
          appearance="primaryReverse"
          onClick={onEnter}
        >
          Enter Results
        </Button>
        <Button
          ghost
          appearance="primaryReverse"
          onClick={() => toast.warning('Currently this feature is only available on mobile')}
        >
          Schedule
        </Button>
      </Flex>
    )}
  </S.Header>
);

WorkoutExercisesHeader.defaultProps = {
  visibleBookmark: false,
};

export default WorkoutExercisesHeader;
